import React from 'react'

const Dropzone = ({pickFiles, children}) => {
  const dragOver = (e) => {
    e.stopPropagation()
    e.preventDefault()
    e.dataTransfer.dropEffect = 'copy'
  }

  const handleFiles = (e) => {
    e.stopPropagation()
    e.preventDefault()
    pickFiles(e)
  }

  return (
    <div onDragOver={dragOver} onDrop={handleFiles} style={{display: ''}}>
      {children}
    </div>
  )
}

Dropzone.propTypes = {
  pickFiles: React.PropTypes.func.isRequired,
  children: React.PropTypes.object
}

export default Dropzone



// WEBPACK FOOTER //
// ./src/components/NewHorse/Uploader/Dropzone.js